import { SharingArrangementModelType } from '@g2-shared/api-client/generated/settlement-app';

export const SharingArrangementModelTypeLabelMapper: Record<SharingArrangementModelType, string> = {
  [SharingArrangementModelType.AGENT_MODEL]: 'Agent_model',
  [SharingArrangementModelType.SERVICE_PROVIDER_MODEL]: 'Service_provider_model',
};
